<template>
    <div>
        <div class="login_header">
            <div class="logo">
                <img src="../../assets/img/logo.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <el-button class="dengluBtn" @click="backBtn">{{$t('meg.Return')}}</el-button>
        </div>
        <div class="login_main">
            <div class="left_main">
                <div class="imgBox">
                    <img src="../../assets/img/login_logo.png" alt="" style="width: 100%;height: 100%;">
                </div>
                <p
                    style="font-size: 57px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;margin-left: -460px;margin-bottom: 0;">
                    开拓｜创新｜诚信</p>
                <p
                    style="font-size: 19px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 300;color: #FFFFFF;margin-left: -220px;text-align: left;">
                    关注行业趋势、紧跟用户需求、提供高质量服务、寻求高层次发展</p>
            </div>
            <div class="right_login">
                <div style="display: flex;">
                    <div class="kehuduan " :class="{active:choseLogin == '1'}" @click="loginTab('1')">{{$t('meg.Client')}}</div>
                    <div class="shengchan" :class="{active:choseLogin == '2'}" @click="loginTab('2')">{{$t('meg.Manufacturer')}}</div>
                </div>
                <div class="login_form">
                    <p v-if="choseLogin == '1'"
                        style="font-size: 18px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #333333;text-align: left;margin-top: 15px;margin-left: 28px;">
                        {{$t('meg.client')}}</p>
                        <p v-if="choseLogin == '2'"
                        style="font-size: 18px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #333333;text-align: left;margin-top: 15px;margin-left: 28px;">
                        {{$t('meg.manufacturer')}}</p>
                    <div style="margin: 13px 25px;">
                        <el-form :model="loginForm" :rules="loginRules">
                          <el-form-item prop="userName">
                            <el-input v-model="loginForm.userName" :placeholder="$t('meg.Username')" class="input" :prefix-icon="User">
                            </el-input>
                          </el-form-item>
                          <el-form-item prop="password">
                            <el-input show-password type="password" v-model="loginForm.password" :placeholder="$t('meg.Password')" class="input" :prefix-icon="Lock">
                            </el-input>
                          </el-form-item>
                        </el-form>
                    </div>
                    <p style="font-size: 12px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #333333;text-align: right;margin-right: 20px;cursor: pointer;" @click="forgetBtn">忘记密码?</p>
                    <el-button class="loginBtn" @click="loginBtn">{{$t('meg.Login')}}</el-button>
                    <p style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #002FA7;margin-top: 30px;cursor: pointer;" @click="registerBtn()">{{$t('meg.registration')}}》</p>
                </div>
            </div>
        </div>
        <div class="login_bottom">
            <p style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #333333;">{{$t('meg.home')}} | {{$t('meg.news')}} | {{$t('meg.introduction')}} | {{$t('meg.productmall')}}</p>
            <p style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #333333;">鲁ICP备20024537号1 Copyright @2020-2025 山东汇泉工业有限公司</p>
        </div>
    </div>  
</template>

<script setup>
import { Search,User,Lock } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router';
import { login } from "@/api/login.js"
import { ref,reactive } from 'vue';
import { ElMessage } from 'element-plus'
const router = useRouter()
const choseLogin = ref('1')
const roleType = ref("")

const loginTab = (index) => {
    choseLogin.value = index
}
const registerBtn = () => {
    router.push("/register")
}
 let checkUserName = (rule, value, callback) => {
      if(value && !/^\w+$/.test(value)){
        return callback(new Error("用户名只能是数字、字母或者下划线"));
      }else{
        callback();
      }
    };
const loginForm = reactive({
    userName:"",
    password:""
})
const loginRules =reactive({
        userName : [
          { required: true, trigger: "blur", message: "用户名不能为空" },
          { max: 30, message: "用户名最大不能超过30位", trigger: "blur" },
        ],
        password: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ],
        // code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
        code: [],
      }) 

const loginBtn = () => {
    let obj = {
        username:loginForm.userName,
        password:loginForm.password
    }
    login(obj).then(res => {
        if(res.data.code == 200) {
            const token = res.data.data.access_token
            const userName = res.data.data.loginUser.username
            roleType.value = res.data.data.loginUser.sysUser.roles[0].roleType
            if(roleType.value == 0) {
                ElMessage.error("您没有权限，请去注册")
                return
            }
            if(roleType.value == choseLogin.value) {
                localStorage.setItem('access_token', token);
                localStorage.setItem('userName', userName);
                router.push({path:'/management',query:{roleType:roleType.value}})
            } else {
                ElMessage.error("请选择正确的商端登录")
                return
            }
        } else {
            ElMessage.error(res.data.msg)
            return
        }
    })
}

const forgetBtn = () => {
    router.push("/forgerpassword")
}

const backBtn = () => {
    router.push("/")
}
</script>

<style scoped>
.login_header {
    height: 80px;
    display: flex;
    justify-content: space-around;
}

.logo {
    width: 84px;
    height: 69px;
    margin-top: 15px;
}

.dengluBtn {
    background-color: #F7B02D;
    color: #333;
    /* width: 113px; */
    height: 43px;
    font-weight: 700;
    border: 0;
    margin-top: 29px;
}

.login_main {
    margin-top: 15px;
    height: 687px;
    background: url("../../assets/img/login_bg.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    justify-content: center;
}

.left_main {
    width: 550px;
    margin-top: 189px;
}

.imgBox {
    width: 74px;
    height: 69px;
}

.right_login {
    width: 350px;
    margin-top: 111px;
}

.kehuduan {
    width: 175px;
    height: 48px;
    line-height: 48px;
    border-radius: 4px 0px 0px 0px;
    opacity: 1;
    background: #E3E3E3;
    border-radius: 0px 4px 0px 0px;
    opacity: 1;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #777777;
    cursor: pointer;
 
}
.active {
    font-size: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #FFFFFF!important;
    background: #002FA7!important;
}

.shengchan {
    width: 175px;
    height: 48px;
    line-height: 48px;
    background: #E3E3E3;
    border-radius: 0px 4px 0px 0px;
    opacity: 1;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #777777;
    cursor: pointer;
}

.login_form {
    width: 350px;
    /* height: 353px; */
    background: #FFFFFF;
    box-shadow: -2px 0px 8px 1px rgba(6, 0, 1, 0.1);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    overflow: hidden;
    padding-bottom: 27px;
}
.input {
    width: 299px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #E5E5E5;
}
::v-deep .el-input__icon {
    font-size: 20px;
}
.loginBtn {
    width: 300px;
    height: 40px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FEFEFE;
}
.login_bottom {
    padding-top: 88px;
    padding-bottom: 40px;
}
</style>
